import {
  useActionItem,
  useCurrentUser,
  ActionItemOperation as Operation,
} from '@workboard/action-item';

import { useModal } from '../../utils/useModal';
import { normalizeToUnixSeconds } from '../../utils/actionItemUtcDates';
import { AICopyStandaloneDialog } from '../../CopyAiModal';

export function useCopyModal(aiId: string | null) {
  const { isPermitted, actionItem } = useActionItem(aiId);
  const currentUser = useCurrentUser();
  const canCopy = isPermitted(Operation.copy);

  const isPrivate = actionItem?.isPersonal || actionItem?.isPrivate;
  const isOwnedByCurrentUser = actionItem?.assignee?.id === currentUser.id;
  const workstreamId =
    isPrivate && isOwnedByCurrentUser
      ? undefined
      : actionItem?.workstreamContext?.workstream?.id;

  const initialData = {
    assigneeId: actionItem?.assignee?.id,
    confidence: actionItem?.confidence,
    dueDateTimestamp: actionItem?.dueDate
      ? normalizeToUnixSeconds(actionItem.dueDate)
      : null,
    effort: actionItem?.effort,
    fromDateTimestamp: actionItem?.startDate
      ? normalizeToUnixSeconds(actionItem.startDate)
      : null,
    title: actionItem?.title,
    priority: actionItem?.priority,
    stateId: actionItem?.state,
    workstreamId,
    createNew: false,
    assigneePic: actionItem?.assignee?.imgUrl,
    assigneeFullName: actionItem?.assignee?.userName,
    workstreamName: workstreamId
      ? actionItem?.workstreamContext?.workstream?.title
      : '',
  };

  const { show: showCopyModal } = useModal(AICopyStandaloneDialog, {
    id: aiId,
    initialData,
  });

  return [canCopy, showCopyModal] as const;
}
